<template>
    <div class="flex gap-5 text-xs text-grey-90">
        <div class="flex items-center"><span class="mr-1">{{ t('journalName') }}: </span>
            <span>{{ item.JOURNAL }}</span></div>
        <div class="flex items-center" v-if="item.WEBSITE && item.WEBSITE.length > 0">
            <span class="mr-1">{{ t('website') }}:</span>
            <a :href="item.WEBSITE[0].url" target="_blank" class="text-eureka-500">{{ item.WEBSITE[0].name }}</a>
        </div>
        <div class=" flex shrink-0 items-center" v-if="item.AUTHORS && item.AUTHORS.length > 0">
            <span class="mr-1">{{ t('author') }}:</span>
            <span class="mr-2" v-html="item.AUTHORS[0].name"></span>
            <div class="th-dropdown th-dropdown-hover" v-if="item.AUTHORS.length > 1">
                <label tabindex="0" class="mb-2 cursor-pointer">+{{ showAuthorsInfoCounts }}</label>
                <div tabindex="0" class="th-dropdown-content th-menu z-10 w-64 p-2">
                    <div v-for="(it, index) in item.AUTHORS" :key="index" class="flex items-center gap-1 py-1">
                        <span class="truncate" :title="it.name" v-html="it.name"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ISolution } from '@eureka/solution-card/src/types';
import _ from 'lodash';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const props = defineProps<{
    item: ISolution
}>();
const showAuthorsInfoCounts = computed(() => {
    return _.get(props.item, 'AUTHORS', []).length ? _.get(props.item, 'AUTHORS', []).length - 1 : 0
})
</script>
